// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import brnEntity from './entities/brn.json';
import brnMenu from '../pages/brn/menu.json';
import brnFullForm from '../pages/brn/forms/full.json';
import brnContextForm from '../pages/brn/forms/context.json';
import brnMiniForm from '../pages/brn/forms/mini.json';
import brnLookupForm from '../pages/brn/forms/lookup.json';
import brnTableView from '../pages/brn/views/table.json';
import brnStagesView from '../pages/brn/views/stages.json';
import brnCardsView from '../pages/brn/views/cards.json';
import brnInlineView from '../pages/brn/views/inline.json';
import brnBacklogView from '../pages/brn/views/backlog.json';
import brnSplitView from '../pages/brn/views/split.json';
import brnCalendarView from '../pages/brn/views/calendar.json';
import brnDashboardView from '../pages/brn/views/dashboard.json';

/** Тип запису «Осередок» зі сторінками пакета: меню, форми та подання з pages/brn/. */
export const brnDefinition: IRecordTypeDefinition = {
  ...brnEntity,
  views: assembleViewSet({
      table: brnTableView,
      stages: brnStagesView,
      cards: brnCardsView,
      inline: brnInlineView,
      backlog: brnBacklogView,
      split: brnSplitView,
      calendar: brnCalendarView,
      dashboard: brnDashboardView,
  }),
  form: brnFullForm,
  forms: { full: brnFullForm, context: brnContextForm, mini: brnMiniForm, lookup: brnLookupForm },
  menu: brnMenu,
} as IRecordTypeDefinition;
